// import all images from assets/images directory
import img01 from "../all-images/outsource-con.png";
import img02 from "../all-images/recruit-con.png";
import img03 from "../all-images/schola-con.png";
import img04 from "../all-images/HR-con.png";


const carData = [
  {
    id: 1,
    
    rating: 112,
    carName: "Outsourcing services",
    imgUrl: img01,
    
    description:
      " we are not just an employee allocation service, we are a comprehensive one-stop service center for all your HR needs",
  },

  {
    id: 2,
    
    carName: "Recruitment services",
    imgUrl: img02,
    
    description:
      " we have the necessary tools to effectively manage recruitment process for your company ",
  },

  {
    id: 3,
    carName: "Scholarships Applications",
    imgUrl: img03,
    description:
      " We help students identify suitable scholarships based on their qualifications and aspirations ",
  },

  {
    id: 4,
    carName: "Human resourcing pooling",
    imgUrl: img04,
    description:
      " we are not just an employee allocation service, we are a comprehensive one-stop service center for all your HR needs ",
  },

  
];

export default carData; 